import Link from "next/link";

import Multimedia from "@sharedComponents/multimedia";

import NoImage from "@assets/images/no-image.svg";
import tileStyle from "./main.module.scss";

const StoreCard = (props) => {
  const {
    data: { id, topBanner, name, feUrl },
  } = props;

  return (
    <div key={id}>
      <Link href={feUrl} passHref prefetch={false}>
        <div className={`${tileStyle.shopTile} ${tileStyle.shopGiftTile}`}>
          <div className={tileStyle.imageBlock}>
            <div className={tileStyle.slideItem}>
              <Multimedia
                type="image"
                src={topBanner || NoImage}
                width={1200}
                height={400}
                className={tileStyle.cardImage}
              />
            </div>
          </div>
          <div className={tileStyle.shopTitleName}>{name}</div>
        </div>
      </Link>
    </div>
  );
};

export default StoreCard;
